import routes from 'constants/routes'

/**
 * Is Presentations switched on for this build? (MYD-494)
 *
 * `main` deploys straight to production, and the gallery landed before the
 * editor (MYD-495) and presenter (MYD-496). Until those exist, a visible
 * sidebar item would let customers create decks they cannot edit or present.
 * So the sidebar item and every /presentations route are hidden unless
 * `REACT_APP_PRESENTATIONS_ENABLED=true`.
 *
 * CRA inlines REACT_APP_* at BUILD time, so flipping it in Render needs a
 * redeploy, not just a restart. Locally, set it in frontend/.env.local.
 *
 * A function rather than a constant so tests can set the variable per case.
 */
export const isPresentationsEnabled = (): boolean => process.env.REACT_APP_PRESENTATIONS_ENABLED === 'true'

/** `/presentations/:id/edit` for a deck. */
export const presentationEditPath = (id: string) => routes.PRESENTATION_EDIT.replace(':id', encodeURIComponent(id))

/** `/presentations/:id/present` for a deck. */
export const presentationPresentPath = (id: string) => routes.PRESENTATION_PRESENT.replace(':id', encodeURIComponent(id))

/** `/presentations/:id/presenter-view` for a deck: the presenter's second window (MYD-497). */
export const presenterViewPath = (id: string) => routes.PRESENTATION_PRESENTER_VIEW.replace(':id', encodeURIComponent(id))
